import React, { useEffect, useRef, useState } from 'react';
import { openSessionLoginModal } from "../../common/api/hooks/useAxiosPrivate";
import { Box } from '@mui/material';
import Pricing from './pricing';
import { useAxiosWithAuth } from '../../common/api/hooks/useAxiosWithAuth';
import { URL } from '../../common/api/urls';
import useRefreshToken from '../../common/hooks/useRefreshToken';
import { useLocation } from 'react-router-dom';
import { SUBSCRIPTION_PLAN_TYPE, SUBSCRIPTION_PLANS_NSE_NEW, SUBSCRIPTION_PLANS, TEXT_MSGS, PAYMENT_STATUS, PAYMENT_METHOD_CCAVENUE,PAYMENT_METHOD_RAZORPAY, EXCHANGE_MODES } from '../../common/utility/constant';
import OrderDetailPopup from './components/order_detail_popup';
import LoginModal from '../../components/landing/sections/LoginPopupNew';
import $ from 'jquery';
import AppErrorPopup from '../../components/AppErrorPopup';
import {
  captureChartsCheckoutStarted,
  captureChartsPaymentFailed,
  captureChartsPaymentSucceeded,
  captureChartsSubscriptionStarted,
  planTierFromPlanName,
} from '../../analytics/chartsFunnel';

const Subscription02 = () => {
  // State for payment flow
  const [planName, setPlanName] = useState(undefined);
  const [showorderPopup, setShowOrderPopup] = useState(false);
  const [orderDetailsData, setOrderDetailsData] = useState();
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [loginMsg, setLoginMsg] = useState(TEXT_MSGS.LOGIN_POPUP_MSG);
  const [isInternational, setIsInternational] = useState(false);
  const [amountDifference, setAmountDifference] = useState(0);
  const orderContextRef = useRef({
    planName: undefined,
    isFlexAddOn: false,
  });

  const location = useLocation();
  const refresh = useRefreshToken();
  
  const [msgState, setMsgState] = useState({
    open: false,
    msg: "",
    severity: "info"
  });
  const { open, msg, severity } = msgState;

  // API hooks for payment
  const [cancelOrder, responseDataOrder, errorOrder, loadedOrder, resetOrder, executeAPIOrder] = useAxiosWithAuth();
  const [cancelStatus,responseDataStatus,errorStatus,loadedStatus,resetStatus,executeAPIStatus] = useAxiosWithAuth();
  const [cancelOrderDetail, responseDataOrderDetail, errorOrderDetail, loadedOrderDetail, resetOrderDetail, executeAPIOrderDetail] = useAxiosWithAuth();

  // Handle snackbar close
  const handleClose = (event, reason) => {
    setMsgState({ ...msgState, open: false });
  };

  // Handle payment continuation
  const continuePayment = (code, method) => {
    setShowOrderPopup(false);
    const { planName: selectedPlanName, isFlexAddOn: isFlexAddOnSelected } = orderContextRef.current;
    const checkoutPlanName = selectedPlanName ?? planName;

    captureChartsCheckoutStarted({
      plan_name: checkoutPlanName,
      plan_tier: planTierFromPlanName(checkoutPlanName),
      payment_provider: method,
    });

    const data = {
      "plan_name": checkoutPlanName,
      "status_check": 0,
      "disc_coupon": code,
      "payment_method": method
    }

    if (isFlexAddOnSelected) {
      data["flex"] = 1;
    }
    executeAPIOrder(URL.SUBSCRIPTION_ORDER, "POST", data)
  };

  // Map subscription plan selection to plan name
  const getPlanName = (planType, isIndex, isInternational, billingType, exchange) => {
    let plan_name;
    const amtDifference = 0;

    const periodKeyByBilling = {
      monthly: 1,
      quarterly: 3,
      half_yearly: 6,
      annually: 12
    };

    const periodKey = periodKeyByBilling[billingType];
    const isBSEExchange = exchange === true || exchange === EXCHANGE_MODES.NSE_BSE;

    if (planType === SUBSCRIPTION_PLAN_TYPE.PROFESSIONAL) {
      if (isInternational) {
        plan_name = isIndex
          ? SUBSCRIPTION_PLANS_NSE_NEW[`PROFESSIONAL_INDEX_MONTHLY_${periodKey}_INTERNATIONAL`]
          : SUBSCRIPTION_PLANS_NSE_NEW[`PROFESSIONAL_INDEX_STOCKS_MONTHLY_${periodKey}_INTERNATIONAL`];
      } else if (exchange === EXCHANGE_MODES.BSE_TOP_UP) {
        plan_name = SUBSCRIPTION_PLANS_NSE_NEW.PROFESSIONAL_BSE_INDEX_MONTHLY_1;
      } else if (isBSEExchange) {
        plan_name = isIndex
          ? SUBSCRIPTION_PLANS_NSE_NEW[`PROFESSIONAL_NSE_INDEX_BSE_INDEX_MONTHLY_${periodKey}`]
          : SUBSCRIPTION_PLANS_NSE_NEW[`PROFESSIONAL_NSE_STOCKS_BSE_INDEX_MONTHLY_${periodKey}`];
      } else {
        plan_name = isIndex
          ? SUBSCRIPTION_PLANS_NSE_NEW[`PROFESSIONAL_MONTHLY_${periodKey}`]
          : SUBSCRIPTION_PLANS_NSE_NEW[`PROFESSIONAL_STOCKS_MONTHLY_${periodKey}`];
      }
    }

    if (planType === SUBSCRIPTION_PLAN_TYPE.ELITE) {
      if (isInternational) {
        plan_name = isIndex
          ? SUBSCRIPTION_PLANS_NSE_NEW[`ELITE_INDEX_MONTHLY_${periodKey}_INTERNATIONAL`]
          : SUBSCRIPTION_PLANS_NSE_NEW[`ELITE_INDEX_STOCKS_MONTHLY_${periodKey}_INTERNATIONAL`];
      } else if (exchange === EXCHANGE_MODES.BSE_TOP_UP) {
        plan_name = SUBSCRIPTION_PLANS_NSE_NEW.ELITE_BSE_INDEX_MONTHLY_1;
      } else if (isBSEExchange) {
        plan_name = isIndex
          ? SUBSCRIPTION_PLANS_NSE_NEW[`ELITE_NSE_INDEX_BSE_INDEX_MONTHLY_${periodKey}`]
          : SUBSCRIPTION_PLANS_NSE_NEW[`ELITE_NSE_STOCKS_BSE_INDEX_MONTHLY_${periodKey}`];
      } else {
        plan_name = isIndex
          ? SUBSCRIPTION_PLANS_NSE_NEW[`ELITE_INDEX_MONTHLY_${periodKey}`]
          : SUBSCRIPTION_PLANS_NSE_NEW[`ELITE_INDEX_STOCKS_MONTHLY_${periodKey}`];
      }
    }

    return { plan_name, amtDifference };
  };


  // Handle subscription click from pricing component
  const handleSubscriptionClick = (planType, isIndex, isInternational, billingType, exchange, addOnTerm) => {
    const { plan_name, amtDifference } = getPlanName(planType, isIndex, isInternational, billingType, exchange);
    const shouldUseFlex =
      exchange === EXCHANGE_MODES.BSE_TOP_UP && addOnTerm === "flex";
    
    if (isInternational) {
      setIsInternational(true);
      setAmountDifference(amtDifference);
    } else {
      setIsInternational(false);
      setAmountDifference(0);
    }
    
    console.log("Orderdetails= call 1 plan=", plan_name);
    orderContextRef.current = {
      planName: plan_name,
      isFlexAddOn: shouldUseFlex,
    };
    setPlanName(plan_name);
    const data = {
      "plan_name": plan_name,
      "status_check": 1,
      "payment_method": PAYMENT_METHOD_CCAVENUE
    };

    if (shouldUseFlex) {
      data["flex"] = 1;
    }

    executeAPIOrderDetail(URL.SUBSCRIPTION_ORDER, "POST", data);
  };

  const handleNamedPlanClick = (plan_name) => {
    setIsInternational(false);
    setAmountDifference(0);
    orderContextRef.current = {
      planName: plan_name,
      isFlexAddOn: false,
    };
    setPlanName(plan_name);
    const data = {
      "plan_name": plan_name,
      "status_check": 1,
      "payment_method": PAYMENT_METHOD_CCAVENUE,
    };
    executeAPIOrderDetail(URL.SUBSCRIPTION_ORDER, "POST", data);
  };

  // Handle ecourse click from pricing component
  const handleEcourseClick = () => {
    console.log("handleClickEcourse=");
    let plan_name = SUBSCRIPTION_PLANS.VMR_ECOURSE;
    orderContextRef.current = {
      planName: plan_name,
      isFlexAddOn: false,
    };
    setPlanName(plan_name);
    const data = {
      "plan_name": plan_name,
      "status_check": 1,
      "payment_method": PAYMENT_METHOD_CCAVENUE,
    };
    executeAPIOrderDetail(URL.SUBSCRIPTION_ORDER, "POST", data);
  };

   const loadScript = (src) =>
    new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });

  const openRazorpay = async (data) => {
    const loaded = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
    if (!loaded) {
      setMsgState({
        open: true,
        msg: "Razorpay SDK failed to load",
        severity: "error",
      });
      return;
    }

    const options = {
      key: data.access_code,
      order_id: data.encRequest.rzp_order_id,
      amount: data.encRequest.amount,
      currency: data.encRequest.currency,

      name: "Vtrender™ Charts",
      description: data.encRequest.merchant_param2,

      prefill: {
        name: data.encRequest.billing_name,
        email: data.encRequest.billing_email,
        contact: data.encRequest.billing_tel,
      },

      handler: () => {
        // IMPORTANT: do nothing critical here
        // webhook will handle
        // This handler only runs when payment is success by default 
        captureChartsPaymentSucceeded({
          plan_name: data.encRequest?.merchant_param2 || orderContextRef.current.planName,
          payment_provider: PAYMENT_METHOD_RAZORPAY,
        });
        captureChartsSubscriptionStarted({
          plan_name: orderContextRef.current.planName,
          plan_tier: planTierFromPlanName(orderContextRef.current.planName),
        });
        verifyRefreshToken();
      },

      modal: {
        ondismiss: () => {
          captureChartsPaymentFailed({
            plan_name: orderContextRef.current.planName,
            payment_provider: PAYMENT_METHOD_RAZORPAY,
            failure_reason: 'cancelled',
          });
          setMsgState({
            open: true,
            msg: "Payment cancelled",
            severity: "warning",
          });
        },
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };


  // API response handler for order creation (payment gateway redirect)
  useEffect(() => {
    if (loadedOrder) {
      if (responseDataOrder != null) {
        if (responseDataOrder.success != undefined && responseDataOrder.success == true) {
          console.log(responseDataOrder);
          if (responseDataOrder.payment_method === PAYMENT_METHOD_RAZORPAY) {
            openRazorpay(responseDataOrder);
          }
          else {
          let url = 'https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction';
          if (responseDataOrder.type != undefined && responseDataOrder.type == "test") 
            url = 'https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction';
          
          let form = $('<form action="' + url + '" method="post">' +
            '<input type="hidden" id="encRequest" name="dtype" value="' + responseDataOrder.type + '">' +
            '<input type="hidden" id="encRequest" name="encRequest" value="' + responseDataOrder.encRequest + '">' +
            '<input type="hidden" name="access_code" id="access_code" value="' + responseDataOrder.access_code + '">' +
            '</form>');

          $('body').append(form);
          form.submit();
          }
        }
      } else if (errorOrder !== null) {
        captureChartsPaymentFailed({
          plan_name: orderContextRef.current.planName,
          failure_reason: errorOrder?.response?.data?.message || 'order_create_failed',
        });
        if (errorOrder?.response?.status === 401 || errorOrder?.response?.status === 403) {
          console.log("status received =", errorOrder?.response?.status);
          openSessionLoginModal(errorOrder);
        } else {
          setMsgState({ open: true, msg: errorOrder?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`, severity: "error" });
        }
      }
      resetOrder();
    }
  }, [loadedOrder, responseDataOrder, errorOrder, resetOrder]);

  // API response handler for order details (show popup)
  useEffect(() => {
    console.log("OrderDetails=", responseDataOrderDetail);
    if (loadedOrderDetail) {
      if (responseDataOrderDetail != null) {
        if (responseDataOrderDetail.success != undefined && responseDataOrderDetail.success == true) {
          console.log("OrderDetails 1=", responseDataOrderDetail);
          setOrderDetailsData(responseDataOrderDetail);
          setShowOrderPopup(true);
        }
      } else if (errorOrderDetail !== null) {
        if (errorOrderDetail?.response?.status === 401 || errorOrderDetail?.response?.status === 403) {
          console.log("status received =", errorOrderDetail?.response?.status);
          openSessionLoginModal(errorOrderDetail);
        } else {
          setMsgState({ open: true, msg: errorOrderDetail?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`, severity: "error" });
        }
      }
      resetOrderDetail();
    }
  }, [loadedOrderDetail, responseDataOrderDetail, errorOrderDetail, resetOrderDetail]);

  //handle location change for accessing the status of payment
  useEffect(() => {
    console.log('Location changed======>',location);
    if(location.search!=undefined && location.search!=""){
      const searchParams = new URLSearchParams(location.search);
      const status=searchParams.get('status');
      if(status!=undefined && status!=""){
        if(status==PAYMENT_STATUS.SUCCESS){
          const order_id=searchParams.get('order_id');
          if(order_id){
            const data={ "order_id" : order_id };
            captureChartsPaymentSucceeded({
              order_id,
              payment_provider: PAYMENT_METHOD_CCAVENUE,
              plan_name: orderContextRef.current.planName,
            });
            captureChartsSubscriptionStarted({
              plan_name: orderContextRef.current.planName,
              plan_tier: planTierFromPlanName(orderContextRef.current.planName),
            });
            executeAPIStatus(URL.SUBSCRIPTION_STATUS,"POST",data);
          }
        }else{
          const message=searchParams.get('message');
          captureChartsPaymentFailed({
            plan_name: orderContextRef.current.planName,
            payment_provider: PAYMENT_METHOD_CCAVENUE,
            failure_reason: status || 'failed',
          });
          setMsgState({open:true,msg:message?message:TEXT_MSGS.NETWORK_ERROR_MSG,severity:"error"})
        }
      }
    }
  }, [location]);


  /**
   * API response handler subscription data
   */  
  useEffect(() => {
    if(loadedStatus){
      if(responseDataStatus!=null){
        verifyRefreshToken();
      }
      else if(errorStatus!==null){
        setMsgState({open:true,msg:errorStatus?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
        //if unauthorized then redirec it to login page
        if(errorStatus?.response?.status === 401 || errorStatus?.response?.status === 403){
          console.log("status received =",errorStatus?.response?.status)
          // navigate(from, { replace: true });
        }
    }
    resetStatus();
    }
  },[loadedStatus,responseDataStatus]);

  const verifyRefreshToken = async () => {
    try {
        await refresh(true);
    }
    catch (err) {
        console.error(err);
    }
    finally {
        // do a reload here
        let reload_url=`${process.env.REACT_APP_URL}subscription`
        window.location=reload_url
        
    }
  }

  useEffect(() => {
    const mainContainer = document.querySelector('main.MuiGrid-container');
    const mainRoot = document.querySelector('main.MuiGrid-root');
    // The wrapper div in MainLayoutContainer adds top padding to offset the fixed header.
    const paddingWrappers = Array.from(document.querySelectorAll('div[style*="padding-top"], div[style*="paddingTop"]'));
    if (mainContainer) {
      mainContainer.style.paddingTop = '0px';
      mainContainer.style.background = 'transparent';
    }
    if (mainRoot) {
      mainRoot.style.background = 'transparent';
    }
    paddingWrappers.forEach((div) => {
      div.setAttribute('data-prev-pt', div.style.paddingTop || '');
      div.style.paddingTop = '0px';
      div.style.background = 'transparent';
    });

    return () => {
      if (mainContainer) {
        mainContainer.style.paddingTop = '';
        mainContainer.style.background = '';
      }
      if (mainRoot) {
        mainRoot.style.background = '';
      }
      paddingWrappers.forEach((div) => {
        const prev = div.getAttribute('data-prev-pt') || '';
        div.style.paddingTop = prev;
        div.style.background = '';
        div.removeAttribute('data-prev-pt');
      });
    };
  }, []);
  return (
    <>
      <Box sx={{
        display: 'flex',
        justifyContent: 'center', 
        width: '100%',
        minHeight: '100vh',
        background: 'transparent'
      }}>
        <Pricing
          hideLandingHeader={true} 
          onSubscribeClick={handleSubscriptionClick}
          onEcourseClick={handleEcourseClick}
          onNamedPlanClick={handleNamedPlanClick}
        />
      </Box>

      {/* AppErrorPopup for messages */}
      <AppErrorPopup
        open={open}
        message={msg}
        severity={severity}
        onClose={handleClose}
        showCloseX
      />
      {/* Legacy snackbar (replaced by AppErrorPopup)
      <Snackbar 
        onClose={handleClose} 
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }} 
        sx={{ top: "48px" }} 
        open={open} 
        autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION_SHORT}
      >
        <Alert severity={severity} sx={{ width: { mobile: '80%', tablet: "70%", laptop: "40%" } }}>
          {msg}
        </Alert>  
      </Snackbar>
      */}

      {/* Order details popup */}
      {showorderPopup && (
        <OrderDetailPopup 
          data={orderDetailsData} 
          planName={planName} 
          onProceed={continuePayment} 
          onCancel={() => setShowOrderPopup(false)} 
          isFlexAddOn={orderContextRef.current.isFlexAddOn}
          isInternational={isInternational} 
          amountDifference={amountDifference}
        />
      )}

      {/* Login popup */}
      {showLoginPopup && (
        <LoginModal
          variant="sessionExpired"
          open
          onClose={() => setShowLoginPopup(false)}
          msg={loginMsg}
        />
      )}
    </>
  );
};

export default Subscription02;